import { ElementProps, ButtonProps, Button } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { ModalFormModel } from 'shared/lib';

export type ModalFormButtonProps<TModalData> = ButtonProps &
	ElementProps<'button', keyof ButtonProps> & {
		modalData: TModalData;
		'data-test-id'?: string;
	};

export const createModalFormButton = <TModalData, TFormValues extends Record<string, unknown>>(
	modalFormModel: ModalFormModel<TModalData, TFormValues>,
) => {
	const ModalFormButton = forwardRef<HTMLButtonElement, ModalFormButtonProps<TModalData>>(
		({ modalData, className, children, onClick, ...props }, ref) => {
			const clicked = useUnit(modalFormModel.modalButtonClicked);

			return (
				<Button
					ref={ref}
					className={clsx('modal-form-button', className)}
					onClick={(event) => {
						clicked(modalData);
						onClick?.(event);
					}}
					{...props}
				>
					{children}
				</Button>
			);
		},
	);

	return ModalFormButton;
};
